export default __webpack_public_path__ + "static/media/GothamBold.f9a5c924.otf";